export const formatValue = (value: number | undefined, step = 2): string => {
  if (value === undefined || value === null) {
    return '-'
  }

  const numericValue = Number(value)
  if (isNaN(numericValue)) {
    return '-'
  }

  return (numericValue / 100).toFixed(step)
}
